// extracted by mini-css-extract-plugin
export default {"switch_btn":"styles_switch_btn__O4qFA","switch_btn_label":"styles_switch_btn_label__BWN9W","btn_container":"styles_btn_container__+Ws62","cancel_btn":"styles_cancel_btn__rEn6k"};